<template>
  <div class="list">
    <van-nav-bar
      :title="'成绩列表'"
      left-arrow
      fixed
      @click-left="onClickLeft"
    />
<!--    <van-search
      v-model="queryParams.studentnumber"
      shape="round"
      background="#F8F8F8"
      @search="onLoad"
      placeholder="请输入搜索关键词"
    />-->
    <van-empty v-if="isempty" description="暂无数据" />
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <van-row v-for="(item,index) in list" :key="index" class="xitem"   justify="space-between">
        <van-col span="16">
          <h4>{{ item.kcmc }}[{{item.kch}}] </h4>
          <p>学期：{{ item.xnxq }}  </p>
          <p>姓名：{{item.studentname}}</p>
          <p>学号：{{item.studentnumber}}</p>
        </van-col>
        <van-col span="7">
          <h4  :style="item.scores < 60 ? 'color: red':'color: green'">{{item.scores ==null || item.scores == '' ? 0 : item.scores }}分 </h4>
        </van-col>
      </van-row>
    </van-list>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        list: [],
        loading:false,
        finished: false,
        value:null,
        total:0,
        isempty:false,
        // 查询参数
        queryParams: {
          pageNum: 1,
          pageSize: 1,
          orderColumn:undefined,
          orderState:undefined,
          xnxq: null,
          kcmc: null,
          studentnumber:null,
          studentname:null,
          paperDesc:null,
        },
      }
    },
    created() {
    },
    methods: {
      onClickLeft() {
        this.$router.go(-1)
      },
      enterTest(id) {
        this.$router.push({ name: 'jiankaoindex', params: { id: id} })
      },
      getxnxq()
      {
        let that = this;
        this.$ajax.get('/teacher/examread/xnxq').then(function (res) {
          that.queryParams.xnxq =  res.data.xnxq;
          that.getjkrw();
        })
      },
      onLoad() {
        let that= this
        let data = {params:this.queryParams}
        this.$ajax.get('/teacher/results/list',data).then(function (res) {
          if (res.code == 200) {
            if(res.rows.length==0)
            {
              that.loading = false;
              that.finished = true;
              that.isempty = true;
              return;
            }
            that.list.push(res.rows[0]);
            that.total = res.total;
            that.loading = false;

            if(that.list.length>=that.total)
            {
              that.finished = true;
            }
            else
            {
              that.queryParams.pageNum ++;
            }
            console.log("输出数据：",that.list)
          }
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  .list{
    margin-top: 4.125rem;
    padding: 0 1.25rem;
    .xitem{
      background-color: #F8F8F8;
      margin-bottom: .9375rem;
      border-radius: 5px;
      padding: .9375rem 1.25rem;
      h4{
        margin: 0;
        line-height: 1.375rem;
        margin-bottom: .5rem;
      }
      p{
        color: #757DA3;
        font-size: .75rem;
        margin: 0;
        margin-top: .125rem;
        line-height: 1.0625rem;
      }
      .enter{
        color: #757DA3;
        display: flex;
        font-size: .875rem;
        justify-content: space-between;
        padding-top: .9375rem;
        margin-top: .625rem;
        position: relative;
        &::after{
          position: absolute;
          width: calc(100% + 2.5rem);
          left: -1.25rem;
          top: 0;
          content: '';
          height: 1px;
          background-color: #EBEBEB;
        }
      }
      span{
        font-size: .75rem;
        &.ing{
          color: #F86969;
        }
        &.end{
          color: #7469F8;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/teacherpage/chengjicx.vue